import {
  AutomaticGroupComponent,
  CommunicationSizeComponent,
  ComponentIds,
  Entity,
  HierarchyUtils
} from '@inter-ikea-core/core';
import { BehaviorParameters } from 'rangeConfig/@types';
import addMultipleFrameExtensions from './addFrameExtensions';
import { ErrorMessages, ProductInfoComponent, ProductType } from '@inter-ikea-storageone/range';

const dragAndDropFrameExtensions = ({
  coreApi,
  dispatch,
  props,
  rootState
}: BehaviorParameters) => {
  const selectedEntity = coreApi.entities.getEntityClosestToPosition(props.position, [
    ComponentIds.FRAME_COMPONENT_ID
  ]);
  if (!selectedEntity) return;

  const baseFrame = HierarchyUtils.findInUpwardsHierarchy(
    selectedEntity,
    e =>
      e.getComponent<ProductInfoComponent>(ProductInfoComponent.id)?.productType ===
      ProductType.BILLY_FRAME_WITH_SHELVES_ASM
  );

  if (!baseFrame) return;

  const extensions = getExtensionsOnFrame(baseFrame, coreApi);
  const entity = extensions.length > 0 ? extensions[extensions.length - 1] : baseFrame;

  const entitySize = entity.getComponent<CommunicationSizeComponent>(
    ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID
  )?.size;

  if (entitySize?.height === 2020 || entitySize?.height === 350) {
    addMultipleFrameExtensions({ coreApi, dispatch, props, rootState, dragAndDropFrame: entity });
  } else {
    coreApi.emit.onPlacementAttempt(ErrorMessages.BillyExtensionSmallFrame);

    // This add will fail since entity has no host connector, but we do it to display the error message
    coreApi.products.addToTarget(props.coreProductId, baseFrame);
  }
};

export default dragAndDropFrameExtensions;

function getExtensionsOnFrame(frame: Entity, coreApi: BehaviorParameters['coreApi']): Entity[] {
  const parent = coreApi.entities.getParent(frame);
  const automaticGroup = parent?.getComponent<AutomaticGroupComponent>(
    ComponentIds.AUTOMATIC_ENTITY_GROUP_COMPONENT_ID
  );
  let extensions = [];

  // To check for existing extensions we must cosider that an autmatic entity group has been created
  // This happens when a door is placed on top of both the base frame and an extension

  // If the automatic group has no members, we can check the hierarcy we normally do
  const members = automaticGroup?.members;
  if (!members) {
    // No group, can use hierarchy as is
    const extension = coreApi.entities.findEntityInHierarchyWithOneOfProductTypes(frame, [
      ProductType.BILLY_FRAME_EXTENSION
    ]);

    const secondExtension =
      extension &&
      coreApi.entities.findDescendantWithOneOfProductTypes(extension, [
        ProductType.BILLY_FRAME_EXTENSION
      ]);

    extensions = [extension, secondExtension].filter(Boolean) as Entity[];
  } else {
    // If we detect membeers, we interate through the mto find products of type extension
    extensions = members?.filter(
      member =>
        member.hasComponent(ComponentIds.FRAME_COMPONENT_ID) &&
        member.getComponent<ProductInfoComponent>(ProductInfoComponent.id)?.productType ===
          ProductType.BILLY_FRAME_EXTENSION
    );
  }

  return extensions;
}
